import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../images/logo.png';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [dark, setDark] = useState(false);

  // Apply dark mode to <html>
  useEffect(() => {
    if (dark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [dark]);

  const navClass = ({ isActive }) =>
    `transition-colors duration-200 ${
      isActive
        ? 'text-blue-600 dark:text-blue-400 font-semibold'
        : 'text-gray-700 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400'
    }`;

  return (
    <nav className="sticky top-0 z-50 border-b bg-white dark:bg-gray-900 dark:border-gray-800">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex h-16 items-center justify-between">

          {/* Logo (Icon only) */}
          <NavLink to="/how-it-works" className="flex items-center">
            <img
              src={logo}
              alt="Logo"
              className="h-8 w-auto object-contain transition-transform hover:scale-105"
            />
          </NavLink>


          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <NavLink to="/how-it-works" className={navClass}>How It Works</NavLink>
            <NavLink to="/who-its-for" className={navClass}>Who It’s For</NavLink>
            <NavLink to="/investors" className={navClass}>Investors</NavLink>

            {/* CTA */}
            <NavLink
              to="/waitlist"
              className="bg-[#C78B46] hover:bg-[#B07A3A] text-white px-5 py-2 rounded-full font-medium transition"
            >
              Join Waitlist
            </NavLink>

            {/* Theme Toggle */}
            <button
              onClick={() => setDark(!dark)}
              className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 transition"
              aria-label="Toggle theme"
            >
              {dark ? (
                // Sun
                <svg className="w-5 h-5 text-yellow-400" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round"
                    d="M12 3v2m0 14v2m9-9h-2M5 12H3m15.364-6.364l-1.414 1.414M7.05 16.95l-1.414 1.414m12.728 0l-1.414-1.414M7.05 7.05L5.636 5.636M12 8a4 4 0 100 8 4 4 0 000-8z"
                  />
                </svg>
              ) : (
                // Moon
                <svg className="w-5 h-5 text-gray-600 dark:text-gray-300" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round"
                    d="M21 12.79A9 9 0 1111.21 3a7 7 0 109.79 9.79z"
                  />
                </svg>
              )}
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-800"
            onClick={() => setOpen(!open)}
          >
            <svg className="w-6 h-6 text-gray-800 dark:text-white" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              {open
                ? <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                : <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
              }
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {/* Mobile Menu */}
{open && (
  <div className="md:hidden py-6 px-4 bg-white dark:bg-gray-900 border-t dark:border-gray-800 animate-in slide-in-from-top duration-300">
    <div className="flex flex-col space-y-6 items-center text-center">
      <NavLink 
        onClick={() => setOpen(false)} 
        className={navClass} 
        to="/how-it-works"
      >
        How It Works
      </NavLink>
      
      <NavLink 
        onClick={() => setOpen(false)} 
        className={navClass} 
        to="/who-its-for"
      >
        Who It’s For
      </NavLink>
      
      <NavLink 
        onClick={() => setOpen(false)} 
        className={navClass} 
        to="/investors"
      >
        Investors
      </NavLink>

      <NavLink
        to="/waitlist"
        onClick={() => setOpen(false)}
        className="w-full max-w-xs bg-[#C78B46] text-white py-4 rounded-full font-bold shadow-lg shadow-orange-100 dark:shadow-none transition-transform active:scale-95"
      >
        Join Waitlist
      </NavLink>

      <button
        onClick={() => setDark(!dark)}
        className="flex items-center gap-2 py-2 text-sm font-medium text-gray-500 dark:text-gray-400 hover:text-[#C78B46]"
      >
        {dark ? (
          <><span role="img" aria-label="sun">☀️</span> Light Mode</>
        ) : (
          <><span role="img" aria-label="moon">🌙</span> Dark Mode</>
        )}
      </button>
    </div>
  </div>
)}
      </div>
    </nav>
  );
}
